import type { LayoutDataType } from '../../types';

export const OPTIONS: {
  title: string;
  id: LayoutDataType['age'];
}[] = [
  // {
  //   id: 'under_18',
  //   title: 'Under 18',
  // },
  {
    id: '18-24',
    title: '18-24',
  },
  {
    id: '25-34',
    title: '25-34',
  },
  {
    id: '35-44',
    title: '35-44',
  },
  {
    id: '45-54',
    title: '45-54',
  },
  {
    id: '55-64',
    title: '55-64',
  },
  {
    id: 'above_64',
    title: 'Above 64',
  },
];
